import {
  initialState,
  Actions,
  State,
  GET_EXPERT_TELEGRAM_GROUP,
  GET_EXPERT_TELEGRAM_GROUP_SUCCESS,
  GET_EXPERT_TELEGRAM_GROUP_ERROR,
  RESET_GET_EXPERT_TELEGRAM_GROUP,
} from "../../types/group/get-expert-telegram-group";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_EXPERT_TELEGRAM_GROUP:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_EXPERT_TELEGRAM_GROUP_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_EXPERT_TELEGRAM_GROUP_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_EXPERT_TELEGRAM_GROUP:
      return {
        ...state,
        states: {
          loading: false,
          error: false,
          success: false,
        },
      };
    default:
      return state;
  }
};

export default reducers;
